import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import React, { useRef, useState } from 'react';
import apis from '../../api';
import image from '../../assets/website-g7a56d42ce_1280.png';
import '../../utils/react-dates-override.css';
import { Label } from './Support.styles';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Support
Description : Pantalla de solicitud de soporte por parte del cliente
Date Autor Modification
================================================================================
22/10/2021 Santiago Coca Rojas Creación – Se implementan la tabla y el formulario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente de acuerdo a los cambios realizados con PrimeReact
================================================================================ */

export default function Support() {
    const [correo, setCorreo] = useState("")
    const [asunto, setAsunto] = useState("")
    const [descripcion, setDescripcion] = useState("")
    const [enviado, setEnviado] = useState(false)

    const [loading1, setLoading1] = useState(false);

    const headers = {
        authorization: localStorage.getItem('token')
    }

    const elementWidth = { width: "20rem" }
    const toast = useRef(null);

    function validarCorreo(correo) {

        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(correo)) {
            return true;
        }
        setLoading1(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error en formato de correo", life: 4000 });
        return false;
    }

    function validateForm() {
        return correo !== "" && asunto !== "" && descripcion !== ""
    }

    async function postSupport() {
        const _entidad = localStorage.getItem('entity')
        const _correo = correo
        const _asunto = asunto
        const _descripcion = descripcion

        const support = {
            ENTITY: _entidad,
            MAILS: _correo,
            SUBJECT: _asunto,
            MESSAGES: _descripcion
        }

        try {
            await apis.postSupportMail(support, headers).then(res => {
                setLoading1(false)
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Solicitud enviada exitosamente. Por favor esté atento a su correo para la respuesta" });
                setEnviado(true)
                setTimeout(() => {
                    window.location.replace("/Employes")
                }, 4000)
            })
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: err.response.data.message, sticky: true });
        }
    }

    return (
        <div className='mt-6'>
            <div className="surface-section w-10 m-auto  mt-6">
                <div class="grid">
                    <div className="col-12">
                        <div style={{ marginBottom: "2rem", marginTop: "4rem" }} className="mb-3 font-bold text-4xl">
                            <span className="text-900">Soporte</span>
                        </div>
                        <Label style={{ fontsize: '10px', marginLeft: "12rem" }} htmlFor="label">(*) Campos obligatorios</Label>
                    </div>
                    <Toast ref={toast} />
                    <div class="col-6">
                        <div class="grid mt-3">
                            <div class="col-10 m-auto">
                                <div className="field">
                                    <div className="p-inputgroup">
                                        <Label htmlFor="label">Correo *</Label>
                                        <InputText
                                            id="label1"
                                            type="text"
                                            style={elementWidth}
                                            className="mt-4 -ml-6"
                                            value={correo}
                                            onChange={(e) => setCorreo(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-10 m-auto">
                                <div className="field">
                                    <div className="p-inputgroup">
                                        <Label htmlFor="label">Asunto *</Label>
                                        <InputText
                                            id="label1"
                                            type="text"
                                            style={elementWidth}
                                            className="mt-4 -ml-6"
                                            value={asunto}
                                            onChange={(e) => setAsunto(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-10 m-auto">
                                <div className="field">
                                    <div className="p-inputgroup">
                                        <Label htmlFor="label">Descripción *</Label>
                                        <InputTextarea className="mt-4 -ml-8" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} rows={5} cols={30} style={elementWidth} />
                                    </div>
                                </div>
                            </div>
                            <div class="col-10 -mt-8 ml-6">
                                <a style={{ textDecoration: 'none' }}>
                                    <Button block label="Enviar" loading={loading1} type="submit" disabled={!validateForm()}
                                        onClick={() => {
                                            setLoading1(true);
                                            if (validarCorreo(correo)) {
                                                postSupport()
                                            }
                                        }} style={{ marginTop: "7rem" }} />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-5 mt-7">
                        <img class="w-full" src={process.env.REACT_APP_SUPPORT} alt="Hola"></img>
                    </div>
                </div>
            </div>
        </div>
    )
}